import clsx from 'clsx';
import { memo, useContext } from 'react';
import { Accessory } from 'src/common/Accessory/Accessory';
import { ValveAccessoriesWithType } from 'src/generated/operations';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { Switch } from 'src/modules/common/components/Switch/Switch';
import { MESSAGES } from 'src/modules/common/constants';
import { GetQty } from 'src/modules/common/utils/parseRecommended';
import { getPriceValue } from 'src/modules/checkout/getPriceValue.ts';
import { ConfigContext } from 'src/configContext.ts';
import { Price } from 'src/common/Price/Price.tsx';

type Props = {
    isSelected: boolean;
    pipeConnectors: ValveAccessoriesWithType[];
    onPipeConnectorsChange: (value: boolean) => void;
    getQty: GetQty;
    isMobile: boolean;
    selectedAccessories: {
        label: string;
        qty: number;
    }[];
    isPricesAllowed?: boolean;
    onSelect?: (label: string) => void;
}

export const AccessoriesPipeConnectors = memo(({
    isSelected,
    pipeConnectors,
    onPipeConnectorsChange,
    onSelect,
    selectedAccessories,
    getQty,
    isMobile,
    isPricesAllowed = true,
}: Props) => {
    const { currency, userSettings } = useContext(ConfigContext);
    return (
        <div className="vss-accessory-grid">
            <div className="vss-accessory-grid__header">
                <h2 className="vss-accessory-grid__title"><I18n messageId={MESSAGES.PipeConnectors}/></h2>
            </div>

            <div className={clsx({
                'vss-accessories-pipe-connectors__content': true,
            })}
            >
                <Switch
                    active={isSelected}
                    onChange={(event) => onPipeConnectorsChange(event.target.checked)}
                    valueActive={
                        <I18n messageId={MESSAGES.pipeConnectorLabel}/>
                    }
                    valueInactive={<I18n messageId={MESSAGES.pipeConnectorLabel}/>}
                    size="sm"
                />
            </div>

            <div className={clsx({
                'vss-accessory-grid__list': true,
                'vss-accessory-grid__list--single': pipeConnectors.length === 1 && !isMobile,
            })}
            >
                {pipeConnectors.map(
                    ({ item }) => {
                        const price = getPriceValue(
                            item,
                            userSettings.shoppingCenter as keyof typeof item,
                            currency,
                        );
                        return (
                            <Accessory
                                qty={`${getQty(item.Label)}x`}
                                accessory={item}
                                selected={selectedAccessories.find(({ label }) => item.Label === label) !== undefined}
                                key={`${item.Label}-${item.ID}`}
                                theme="white"
                                onSelect={onSelect}
                                price={isPricesAllowed ? (
                                    <Price
                                        price={price.value}
                                        currency={price.currency}
                                        locale={userSettings.currentLocale}
                                    />
                                ) : null}
                            />
                        );
                    },
                )}
            </div>
        </div>
    );
});
